
export const ROUTES = {
  ROOT: '/',
  SIGN_UP: '/sign-up',
  SIGN_UP_CONTACT_INFORMATION: '/contact-information',
  SIGN_UP_INSTANCES: '/instances',
  SIGN_UP_ADD_ONS: '/add-ons',
  SIGN_UP_BILLING: '/billing',
  SIGN_UP_ORDER_DETAILS: '/order-details',
  SIGN_UP_CONFIRMATION: '/confirmation',
  SIGN_UP_CONTACT: '/contact'
};

export const MAIN = [
  {
    label: 'Who we are',
    to: 'https://www.baosystems.com/whoweare/'
  },
  {
    label: 'What we do',
    to: 'https://www.baosystems.com/whatwedo/'
  },
  {
    label: 'Hosting',
    to: 'https://www.baosystems.com/hosting/'
  },
  {
    label: 'Contact us',
    to: 'https://www.baosystems.com/contact/'
  }
];

export const ONBOARD = [
  {
    label: 'Contacts',
    to: ROUTES.SIGN_UP_CONTACT_INFORMATION,
    step: 1
  },
  {
    label: 'Instances',
    to: ROUTES.SIGN_UP_INSTANCES,
    step: 2
  },
  {
    label: 'Add-ons',
    to: ROUTES.SIGN_UP_ADD_ONS,
    step: 3
  },
  {
    label: 'Billing',
    to: ROUTES.SIGN_UP_BILLING,
    step: 4
  },
  {
    label: 'Confirmation',
    to: ROUTES.SIGN_UP_CONFIRMATION,
    step: 5
  }
];

export const EXTERNAL = {
  termsAndConditions: 'https://manager.baosystems.com/app/signup/terms.html'
};
